export class ShaqFAQ {
  id: number = 0;
  question: string = '';
  answer: string = '';
  add_date?: string = '';
  edit_date?: string = '';
  //Theoretical
/*
  submitted_by: string = '';
  up_votes: number = 0;
  down_votes: number = 0;
  total_votes: number = 0;*/
}